import {makeStyles} from "@material-ui/core";

export default function useStyles() {
    return makeStyles((theme) => ({

        inline: {            
            cursor: 'pointer',            
            "&:hover": {
                color: theme.palette.primary.main
            },
        },
        data: {                        
            color: '#989898',
            fontSize: '.9em',            
        },
        icons: {
            color: '#159B78 !important',
            width: '18px'
        },
        titlePendencias: {
            fontWeight: 'bold'
        },
    }));
}